<template>
  <div class="container">
    <div class="card">
      <h1>Listener</h1>
      <input v-model="url" type="text" placeholder="Введіть посилання на міт" />
      <p v-if="errorMessage" class="error">{{ errorMessage }}</p>
      <button v-if="!isRunning" class="active" @click="startMeeting">Запустити</button>
      <button v-if="isRunning" @click="stopMeeting">Зупинити</button>

      <!-- Блок для отображения статуса митинга -->
      <div v-if="isRunning" class="meeting-status">
        <h2>Міт запущений</h2>
        <p><strong>Ідентифікатор:</strong> {{ meeting.meetingId }}</p>
        <p><strong>Статус:</strong> {{ meeting.status }}</p>
      </div>

      <!-- Блок для отображения истории митов -->
      <div v-if="meetHistory.length != 0" class="history">
        <h2 @click="toggleHistory">{{ isHistoryOpen ? 'Приховати історію' : 'Показати історію' }}</h2>
        
        <div class="meet-last-div" v-if="!isHistoryOpen && meetHistory.length != 0">
          <p>Останній міт: {{ meetHistory[0].meetingId }} - {{ meetHistory[0].status }}</p><img v-if="meetHistory[0].status == 'Done'" @click="downloadFile(meetHistory[0].meetingId)" src="@/assets/images/download.png">
        </div>

        <div v-if="isHistoryOpen">
          <ul>
            <li class="history-meet-li" v-for="(meeting, index) in meetHistory" :key="index">
              Міт {{ index + 1 }}: Ідентифікатор: {{ meeting.meetingId }}, Статус: {{ meeting.status }}
              <img v-if="meeting.status == 'Done'" @click="downloadFile(meeting.meetingId)" src="@/assets/images/download.png">
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="emma-payment-check-background" v-if="!paymentCheck && !paymentLoad"></div>
      <div v-if="!paymentCheck && !paymentLoad" class="payment-form">
          <h1>Unfortunately, Listener is not free. To pay for a monthly subscription, please follow the link below</h1>
          <a v-if="paymentLink != ''" :href="paymentLink"><p>Payment link</p></a>
          <button @click="checkPayment(byButton=true)">Check payment</button>
          <p class="promo-invalid-p" v-if="showFailedPayment">We could not renew your subscription. To continue using the service, please pay a new invoice</p>
          <p class="promo-invalid-p" v-if="trialPeriodOver">Your trial period has ended. To continue using the service, a subscription payment is required</p>
          <p v-if="showInvalidPaymentCheck" class="promo-invalid-p">Subscription not paid</p>
          <input v-if="showPromocodeInputs" placeholder="Промокод" v-model="promoInput" class="promo-input">
          <p v-if="showInvalidPromo" class="promo-invalid-p">{{ invalidPromoText }}</p>
          <button v-if="showPromocodeInputs" @click="checkPromo" class="promo-check-button">Check promo code<img v-if="checkingPromo" src="@/assets/images/load.gif"></button>
      </div>
  </div>
</template>

<script>
const backendUrl = process.env.VUE_APP_BACKEND_URL;

export default {
  data() {
    return {
      url: '',
      errorMessage: '',
      intervalId: null,
      isHistoryOpen: false,  // Отслеживает состояние истории
      paymentCheck: true,
      paymentLoad: false,
      promoInput: '',
      paymentLink: '',
      showFailedPayment: false,

    };
  },
  methods: {
    async checkPayment(byButton=false) {
      try {
          const response = await fetch(`${backendUrl}/check_payment`, {
              method: 'GET',
              credentials: 'include',
              headers: {
                  'Content-Type': 'application/json'
              },
          })
          const responseData = await response.json()
          if (responseData.status) {
              if (byButton) {
                  this.paymentCheck = true
                  alert('Оплата пройшла успішно') 
              }
              return true                    
          }else {
              if (byButton) {
                  this.showInvalidPaymentCheck = true
              }
              if (responseData.promocode_used) {
                  this.showPromocodeInputs = false
              }
              if (responseData.by_promo) {
                  this.trialPeriodOver = true
              }
              if (responseData.failed_payment) {
                  this.showFailedPayment = true
              }
              return false
          }
      } catch (error) {
          return false
      }

    },
    async checkPromo() {
        this.checkingPromo = true
        try {
            const response = await fetch(`${backendUrl}/check_promo?promo=${this.promoInput}`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                },
            })
            const responseData = await response.json()
            if ('success' in responseData) {
                this.paymentCheck = true
                alert('Оплата пройшла успішно')   
            } else if ('error' in responseData) {
                switch (responseData['error']) {
                    
                    case 'invalid promo':
                        this.invalidPromoText = this.$t('emma.payment.promoError')
                        break
                    case 'already used':
                        this.invalidPromoText = this.$t('emma.payment.promoUsed')
                        break
                    }
                this.showInvalidPromo = true
            }
                
        } catch (error) {
            console.error('Checking promo error', error);
        }
        this.checkingPromo = false
    },
    async startMeeting() {
      this.errorMessage = '';
      if (this.url && !this.isRunning) {
        const result = await this.$store.dispatch('start_meeting', this.url);
        if (!result) {
          this.errorMessage = 'Некорректний формат посилання, будь ласка, введіть правильне посилання.';
        }
      } else {
        alert('Введіть посилання!');
      }
    },
    async stopMeeting() {
      if (this.isRunning) {
        await this.$store.dispatch('stop_meeting')
      }
    },
    toggleHistory() {
      this.isHistoryOpen = !this.isHistoryOpen;
    },
    async downloadFile(meetId) {
      try {
        const response = await fetch(`${backendUrl}/download_file?meet_id=${meetId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          },
          credentials: 'include'
        });
        
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        // Получаем имя файла из заголовков
        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = 'downloaded_file.txt'; // default name
        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?(.+)"?/);
          if (match) {
            filename = match[1];
          }
        }
        // Преобразуем данные в blob
        const blob = await response.blob();
        
        // Создаём ссылку на blob
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename); // задаём имя файла
        document.body.appendChild(link);
        link.click(); // инициируем скачивание
        link.remove(); // удаляем ссылку
      } catch (error) {
        console.error('Failed to download file:', error);
      }
    },
  },
  
  mounted() {
    this.$store.dispatch('get_meeting_status', {});
    this.$store.dispatch('get_meet_history', {});

    this.intervalId = setInterval(() => {
      if (this.isRunning) {
        this.$store.dispatch('get_meeting_status', {});
      }
    }, 2000);
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
  },
  created() {
    this.checkPayment().then((data) => {
      this.paymentLoad = false
      this.paymentCheck = data
      if (!data) {
        if (!this.showFailedPayment) {
            try {
                fetch(`${backendUrl}/stipe_generate_link_monthly`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                },
                }).then(response => {
                    return response.json();
                })
                .then(responseData => {
                    this.paymentLink = responseData
                })
            } catch (error) {
                console.error('Get payment link error', error);
            }
        }else {
            try {
                fetch(`${backendUrl}/create_new_invoice`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                },
                }).then(response => {
                    return response.json();
                })
                .then(responseData => {
                    this.paymentLink = responseData.checkout_session_url
                })
            } catch (error) {
                console.error('Get payment link error', error);
            }
        }
      }
    })
  },
  computed: {
    meeting() {
      return this.$store.state.meeting.meeting;
    },
    isRunning() {
      return this.$store.state.meeting.isRunning;
    },
    meetHistory() {
      return this.$store.state.meeting.meetHistory;
    }
  },
};
</script>

<style>
.payment-form button:hover {
        background: linear-gradient(to top right, rgba(117, 112, 255, 0.9), rgba(188, 112, 255, 0.9));
    }
    .payment-form button {
        background: linear-gradient(to top right, rgba(117, 112, 255, 1), rgba(188, 112, 255, 1));
        margin-top: 12px;
        border: none;
        border-radius: 8px;
        height: 40px;
        color: white;
        padding: 0 8px 0 8px;
        cursor: pointer;
    }
    .payment-form p {
        margin-top: 12px;
        font-size: 14px;
        width: 100%;
        overflow-wrap: break-word
    }
    .payment-form h1 {
        font-size: 16px;
        font-weight: 500;
        text-align: center;
    }
    .payment-form.tutorial {
        background: white;
        margin-left: -8px;
        border-radius: 8px;
        z-index: 10000;
    }
.payment-form {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: fixed;
        top: 50%;
        transform: translateX(-50%) translateY(-50%);
        width: 25%;
        padding: 48px 12px 48px 12px;
        background: white;
        left: 50%;
    }
.promo-invalid-p {
        text-align: center;
        color: red;
    }
    .promo-input {
        margin-top: 24px;
        border: 1px solid #d9bff5;
        border-radius: 8px;
        height: 30px;
        outline: none;
        padding-left: 8px;
        padding-right: 8px;
    }
.promo-check-button {
        display: flex;
        gap: 4px;
        align-items: center;
    }
    .promo-check-button img {
        height: 13px;
    }
    .emma-payment-check-background {
        position: fixed;
        height: 100%;
        width: 100%;
        background: rgba(0, 0, 0, 0.5);
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
.meet-last-div {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
}
.meet-last-div img {
  height: 25px;
  cursor: pointer;
}
.history-meet-li {
  display: flex;
  align-items: center;
}
.history-meet-li img {
  height: 20px;
  cursor: pointer;
}
body,
html {
  margin: 0;
  padding: 0;
  font-family: Arial, sans-serif;
  background-color: #f0f2f5;
  height: 100%;
  width: 100%;
}

body {
  display: flex;
  justify-content: center;
  align-items: center;
}

.container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: relative;
}

.card {
  width: 30%;
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.card h1 {
  margin-bottom: 1.5rem;
  font-size: 1.5rem;
  color: #333;
}

.card input {
  width: 100%;
  padding: 0.5rem;
  margin-bottom: 1rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
  box-sizing: border-box;
}

.card button {
  width: 100%;
  padding: 0.5rem;
  background-color: #e5e5e5;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  color: #777777;
  cursor: pointer;
}

.card button.active {
  color: white;
  background-color: #007bff;
}

.card button.active:hover {
  background-color: #0056b3;
}

.card button:hover {
  background-color: #c9c7c7;
}

.error {
  color: red;
  font-size: 0.9rem;
  margin-bottom: 1rem;
}

/* Стиль для статуса митинга */
.meeting-status {
  margin-top: 1.5rem;
  padding: 1rem;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  text-align: left;
}

.meeting-status h2 {
  margin-bottom: 1rem;
  font-size: 1.25rem;
  color: #28a745;
}

.meeting-status p {
  margin: 0.5rem 0;
  font-size: 1rem;
  color: #333;
}

/* Стиль для истории митов */
.history {
  margin-top: 2rem;
}

.history h2 {
  cursor: pointer;
  font-size: 1.25rem;
  color: #007bff;
  margin-bottom: 0.5rem;
}

.history ul {
  list-style-type: none;
  padding: 0;
}

.history li {
  background-color: #f9f9f9;
  margin-bottom: 0.5rem;
  padding: 0.5rem;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
</style>
